/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */

import { DataGrid, GridToolbar, frFR } from "@mui/x-data-grid";
import {
  Box,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Link,
  TextField,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  Checkbox,
  MenuItem,
  useTheme,
} from "@material-ui/core";
import { useState, useCallback, useEffect } from "react";
import { dashboardApi } from "../../../api/dashboardApi";
import { Link as RouterLink } from "react-router-dom";
import useMounted from "../../../hooks/useMounted";
import useAuth from "../../../hooks/useAuth";
import * as moment from "moment";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CircularProgress from "@mui/material/CircularProgress";
import { getTone, toneAlpha, grey, greyAlpha } from '../../../theme/tones';

const FinanceStatistiqueFormationsSuperAdmin = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const mounted = useMounted();
  const [choiceEndDate, setChoiceEndDate] = useState("default");
  const [choiceFormation, setChoiceFormation] = useState("all");
  const [choiceSource, setChoiceSource] = useState("all");
  const [choiceRelance, setChoiceRelance] = useState("all");
  const [choiceProfession, setChoiceProfession] = useState("all");
  const [choiceFinanceur, setChoiceFinanceur] = useState("all");
  const currentYear = new Date().getFullYear();
  const [choiceYear, setChoiceYear] = useState(currentYear);
  const [choiceMonth, setChoiceMonth] = useState("all");
  const [sessionsInformations, setSessionsInformations] = useState([]);
  const [formationsInfos, setFormationsInfos] = useState([]);
  const [sourcesInfos, setSourcesInfos] = useState([]);
  const [relanceInfos, setRelanceInfos] = useState([]);
  const [rows, setRows] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [financeurs, setFinanceurs] = useState([]);
  const [years, setYears] = useState([]);
  const [choiceFormat, setChoiceFormat] = useState("all");
  const [formats, setFormats] = useState([]); 
  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  const [sessionsEndDate, setSessionsEndDate] = useState([]);
  const [clickedId, setClickedId] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [formationAutocomplete, setFormationAutocomplete] = useState({
    id: "all",
    programNumber: "",
    name: "Toutes",
  });
  const [choiceOptions, setChoiceOptions] = useState([
    { label: "Toutes", value: "default" },
  ]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const detailStyles = {
    borderTop: "2px solid",
    borderTopColor: "primary.main",
    pt: 2,
    whiteSpace: "pre-line",
  };

  const formationsOptions = [];
  formationsOptions.push({ name: "Toutes", id: "all", programNumber: "" });
  formationsInfos.forEach((formation) => {
    formationsOptions.push({
      name: formation.name,
      id: formation.id,
      programNumber: formation.program_number,
    });
  });
  const sourcesOptions = [];
  sourcesOptions.push({ name: "Tous", id: "all" });
  
  // Group all IDs for people with the same name (merge duplicates)
  const sourcesByName = {};
  sourcesInfos.forEach((source) => {
    const fullName = `${source.firstname} ${source.lastname}`;
    if (!sourcesByName[fullName]) {
      sourcesByName[fullName] = [];
    }
    sourcesByName[fullName].push(source.id);
  });
  Object.entries(sourcesByName).forEach(([name, ids]) => {
    sourcesOptions.push({ name, id: ids.join(',') });
  });
  const relanceOptions = [];
  relanceOptions.push({ name: "Tous", id: "all" });
  
  // Group all IDs for people with the same name (merge duplicates)
  const relanceByName = {};
  relanceInfos.forEach((person) => {
    const fullName = `${person.firstname} ${person.lastname}`;
    if (!relanceByName[fullName]) {
      relanceByName[fullName] = [];
    }
    relanceByName[fullName].push(person.id);
  });
  Object.entries(relanceByName).forEach(([name, ids]) => {
    relanceOptions.push({ name, id: ids.join(',') });
  });
  const professionsOptions = [{ name: "Toutes", id: "all" }];
  professions.forEach((profession) => {
    professionsOptions.push({
      name: profession.profession,
      id: profession.profession,
    });
  });
  const yearsOptions = [{ name: "Toutes", id: "all" }];
  years.forEach((year) => {
    yearsOptions.push({ name: year, id: year });
  });

  const financeursOptions = [{ name: "Tous", id: "all" }];
  financeurs.forEach((financeur) => {
    financeursOptions.push({ name: financeur.name, id: financeur.id });
  });

  const monthsOptions = [{ name: "Tous", id: "all" }];
  months.forEach((month, index) => {
    monthsOptions.push({ name: month, id: index + 1 });
  });

  //Joseph_com - Créer les options de format
  const formatsOptions = [{ name: "Tous", id: "all" }];
  Array.isArray(formats) &&
    formats.forEach((format) => {
      formatsOptions.push({ name: format.format, id: format.format });
    });

  // Filtrer les sessionsEndDate en fonction de l'année et du mois
  const updateChoiceOptions = useCallback(
    (year, month) => {
      const filteredSessions = sessionsEndDate.filter((item) => {
        const sessionMonth = new Date(item.end_date).getMonth() + 1;
        const sessionYear = new Date(item.end_date).getFullYear();
        const selectedMonth = parseInt(month, 10);
        return (
          (month === "all" || sessionMonth === selectedMonth) &&
          sessionYear === parseInt(year, 10)
        );
      });

      const newChoiceOptions = [{ label: "Toutes", value: "default" }];
      filteredSessions.forEach((item) => {
        newChoiceOptions.push({
          label: moment(item.end_date).format("DD/MM/YYYY"),
          value: item.end_date,
        });
      });

      setChoiceOptions(newChoiceOptions);
    },
    [sessionsEndDate]
  );

  useEffect(() => {
    const fetchInfos = async () => {
      try {
        const data = await dashboardApi.getInfos(
          localStorage.getItem("accessToken"),
          choiceYear,
          choiceMonth
        );
        if (data.length === 0) {
          throw new Error("Aucune donnée disponible");
        }

        if (mounted.current) {
          setSessionsEndDate(data.sessionsEndDate);
          setFormationsInfos(data.formations);
          setSourcesInfos(data.sources);
          setRelanceInfos(data.relance);
          setProfessions(data.professions);
          setYears(data.years);
          setFinanceurs(data.financeurs);
          setFormats(data.formats); //Joseph_com - Récupération des formats
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchInfos();
  }, [choiceYear, choiceMonth, mounted]);

  useEffect(() => {
    updateChoiceOptions(choiceYear, choiceMonth);
  }, [sessionsEndDate, choiceYear, choiceMonth]);
  const handleInformationsSessions = useCallback(
    async (
      endDates,
      formation,
      source,
      relance,
      profession,
      year,
      month,
      financeur,
      format
    ) => {
      setLoading(true);
      try {
        // Vérifie si endDates est un tableau
        if (!Array.isArray(endDates)) {
          throw new Error("endDates should be an array");
        }

        // Crée un tableau de promesses pour chaque endDate
        const dataPromises = endDates.map((endDate) =>
          dashboardApi.getSessions(
            localStorage.getItem("accessToken"),
            endDate,
            formation,
            source,
            relance,
            profession,
            year,
            month,
            financeur,
            format
          )
        );

        // Attendre que toutes les promesses soient résolues
        const sessionsData = await Promise.all(dataPromises);

        // Concaténer toutes les sessions récupérées en un seul tableau
        const allSessions = sessionsData.flatMap((data) => data.sessions);

        // Filtrer les sessions pour exclure celles avec des informations "N/A"
        const validSessions = allSessions.filter(
          (session) =>
            session.number_session && session.number_session !== "N/A"
        );

        // Appliquer le filtrage selon endDates
        let filteredSessions = validSessions;

        // Si endDates contient plus de deux éléments et que le premier est 'default'
        if (endDates.length > 2 && endDates[0] === "default") {
          // On prend les dates sans le "default"
          const realEndDates = endDates.slice(1);

          filteredSessions = validSessions.filter((session) =>
            realEndDates.includes(session.end_date)
          );
        }

        // Mise à jour de l'état si le composant est toujours monté
        if (mounted.current) {
          setSessionsInformations(filteredSessions);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [mounted]
  );

  const handleChangeOption = async (event) => {
    const newSelection = event.target.value;
    let updatedSelection;

    // Vérifier si 'default' (Toutes) est sélectionné
    if (newSelection.includes("default")) {
      // Si 'default' est déjà sélectionné, le décocher (désélection globale)
      if (selectedOptions.includes("default")) {
        // Si l'utilisateur ajoute une autre date alors que 'default' est présent,
        // retirer 'default' et conserver les autres sélections
        if (newSelection.length > 1) {
          updatedSelection = newSelection.filter((item) => item !== "default");
          setChoiceEndDate(updatedSelection);
        } else {
          // simple toggle off de 'default'
          updatedSelection = [];
          setChoiceEndDate([]);
        }
      } else {
        // Sinon, sélectionner 'default' et toutes les autres dates
        const allDatesExceptDefault = choiceOptions
          .filter((option) => option.value !== "default")
          .map((option) => option.value);
        updatedSelection = ["default", ...allDatesExceptDefault];
        setChoiceEndDate(allDatesExceptDefault); // Sélectionner toutes les autres dates
      }
    } else {
      // Si 'default' n'est pas sélectionné, vérifier s'il était sélectionné précédemment
      if (selectedOptions.includes("default")) {
        // on quitte "Toutes" → prendre la nouvelle sélection sans 'default'
        updatedSelection = newSelection.filter((item) => item !== "default");
        setChoiceEndDate(updatedSelection);
      } else {
        // Mise à jour normale des options sélectionnées
        updatedSelection = newSelection;
        setChoiceEndDate(updatedSelection.filter((item) => item !== "default")); // Mettre à jour avec les nouvelles dates sélectionnées
      }
    }

    setSelectedOptions(updatedSelection);
  };

  const handleChangeOptionSource = (event) => {
    setChoiceSource(event.target.value);
    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      event.target.value,
      choiceRelance,
      choiceProfession,
      choiceYear,
      choiceMonth,
      choiceFinanceur,
      choiceFormat
    );
  };


  const handleChangeOptionRelance = (event) => {
    setChoiceRelance(event.target.value);
    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      choiceSource,
      event.target.value,
      choiceProfession,
      choiceYear,
      choiceMonth,
      choiceFinanceur,
      choiceFormat
    );
  };


  const handleChangeOptionProfession = (event) => {
    setChoiceProfession(event.target.value);
    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      choiceSource,
      choiceRelance,
      event.target.value,
      choiceYear,
      choiceMonth,
      choiceFinanceur,
      choiceFormat
    );
  };


  const handleChangeOptionFinanceur = (event) => {
    setChoiceFinanceur(event.target.value);
    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      choiceSource,
      choiceRelance,
      choiceProfession,
      choiceYear,
      choiceMonth,
      event.target.value,
      choiceFormat
    );
  };


  const handleChangeOptionFormat = (event) => {
    setChoiceFormat(event.target.value);
    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      choiceSource,
      choiceRelance,
      choiceProfession,
      choiceYear,
      choiceMonth,
      choiceFinanceur,
      event.target.value
    );
  };


  const handleChangeOptionYear = (event) => {
    const selectedYear = event.target.value;
    setChoiceYear(selectedYear);
    setChoiceMonth("all");
    setSelectedOptions([]);
    setChoiceEndDate("default");
    updateChoiceOptions(selectedYear, "all");
  };

  const handleChangeOptionMonth = (event) => {
    const selectedMonth = event.target.value;
    setChoiceMonth(selectedMonth);
    setSelectedOptions([]);
    setChoiceEndDate("default");
    updateChoiceOptions(choiceYear, selectedMonth);
  };


  useEffect(() => {
    // Éviter l'appel si choiceOptions n'est pas encore initialisé
    if (choiceOptions.length === 0) return;

    // Si selectedOptions est vide, initialiser avec 'default'
    if (selectedOptions.length === 0) {
      setSelectedOptions(["default"]);
      return;
    }

    handleInformationsSessions(
      selectedOptions,
      choiceFormation,
      choiceSource,
      choiceRelance,
      choiceProfession,
      choiceYear,
      choiceMonth,
      choiceFinanceur,
      choiceFormat
    );
  }, [
    choiceOptions,
    selectedOptions,
    choiceFormation,
    choiceSource,
    choiceRelance,
    choiceProfession,
    choiceYear,
    choiceMonth,
    choiceFinanceur,
    choiceFormat,
  ]);

  // Met à jour les lignes lorsque les sessionsInformations changent
  useEffect(() => {
    const endDateLength = Array.isArray(choiceEndDate)
      ? choiceEndDate.length
      : 0;
    // Vérifier que sessionsInformations est défini et n'est pas vide
    if (sessionsInformations && sessionsInformations.length > 0) {
      let tempRows = sessionsInformations.slice();

      if (tempRows.length === 2) {
        tempRows.splice(1, 1); // Supprimer le deuxième élément si tempRows contient exactement 2 éléments
      } else if (tempRows.length > 5 && endDateLength === 0) {
        tempRows.unshift(
          JSON.parse(JSON.stringify(tempRows[tempRows.length - 1]))
        ); // Ajouter une copie du dernier élément en début de tableau
        tempRows[0].id = Math.max(...tempRows.map((el) => el.id)) + 1; // Assurer que le nouvel élément a un ID unique
      }

      // Mapper tempRows en utilisant une logique spécifique
      tempRows = tempRows.map((item, index) => ({
        id: item.id,
        formation: item.name || "N/A",
        format: item.format || "N/A",
        session: item.number_session || "N/A",
        turnoverNotBegun: item.price0 || 0,
        turnoverBegun: item.priceBetween || 0,
        turnoverFinished: item.priceFinished || 0,
        turnoverNotBillable: item.priceNotBillable || 0,
        startDate: item.start_date || "N/A",
        endDate: item.end_date || "N/A",
        city: item.meeting_town || "-", //Joseph_com - Ville (lieu de la présentielle) si disponible
        notBegun: item.percent0 || 0,
        begun: item.percentBetween || 0,
        finished: item.percentFinished || 0,
        notBillable: item.percentNotBillable || 0,
        numberNotBegun: item.count0 || 0,
        numberBegun: item.countBetween || 0,
        numberFinished: item.countFinished || 0,
        numberNotBillable: item.countNotBillable || 0,
        numberRegistered: item.numberTotal || 0,
        numberTurnoverRegistered: item.priceTotal || 0,
        status: item.status || [],
        programNumber: item.program_number || "N/A",
      }));

      // Affecter tempRows à setRows
      setRows(tempRows);
    } else {
      // Si sessionsInformations est vide ou non défini, affecter un tableau vide à setRows
      setRows([]);
    }
  }, [sessionsInformations, choiceEndDate]);

  const columns = [
    {
      field: "+",
      // eslint-disable-next-line no-unused-expressions
      renderCell: (cellValues) => (
        <IconButton
          onClick={() => {
            clickedId === cellValues.row.id
              ? setClickedId(-1)
              : setClickedId(cellValues.row.id);
          }}
          size="small"
          sx={{
            backgroundColor: cellValues.row.id === clickedId
              ? toneAlpha('blue', 0.1)
              : toneAlpha('neutral', 0.06),
            border: '1px solid',
            borderColor: cellValues.row.id === clickedId
              ? toneAlpha('blue', 0.3)
              : toneAlpha('neutral', 0.15),
            borderRadius: '8px',
            width: 28,
            height: 28,
            transition: 'all 0.2s',
            '&:hover': {
              backgroundColor: toneAlpha('blue', 0.12),
              borderColor: toneAlpha('blue', 0.3),
            },
          }}
        >
          {cellValues.row.id === clickedId ? (
            <KeyboardArrowUpIcon sx={{ fontSize: '1rem', color: 'secondary.main' }} />
          ) : (
            <KeyboardArrowDownIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          )}
        </IconButton>
      ),
      width: 60,
    },
    {
      field: "formation",
      headerName: "Formation",
      width: 420,
      renderCell: (cellValues) => {
        const isGlobal = cellValues.row.formation === "Statistique globale";
        return (
          <Box sx={{ py: 0.5, width: '100%' }}>
            {isGlobal ? (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ width: 4, height: 28, borderRadius: '3px', backgroundColor: getTone('blue').base, flexShrink: 0 }} />
                  <Typography sx={{ fontWeight: 800, fontSize: '0.85rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
                    {cellValues.row.formation}
                  </Typography>
                </Box>
                <Collapse in={cellValues.id === clickedId}>
                  <Box sx={{ mt: 1, pt: 1, borderTop: `1px solid ${greyAlpha(200, 0.7)}` }}>
                    {cellValues.row.status.map((el, idx) => {
                      const isPositive = el.status === 'Inscrit' || el.status === 'InscritD';
                      const isNegative = el.status === 'Annulation' || el.status === 'À décaler';
                      const isHighlight = el.percentByStatus > 49;
                      return (
                        <Box
                          key={idx}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0.5,
                            mr: 0.5,
                            mb: 0.4,
                            px: 1,
                            py: 0.25,
                            borderRadius: '6px',
                            backgroundColor: isHighlight && isPositive
                              ? toneAlpha('emerald', 0.08)
                              : isHighlight && isNegative
                              ? toneAlpha('rose', 0.08)
                              : toneAlpha('neutral', 0.06),
                            border: '1px solid',
                            borderColor: isHighlight && isPositive
                              ? toneAlpha('emerald', 0.2)
                              : isHighlight && isNegative
                              ? toneAlpha('rose', 0.2)
                              : toneAlpha('neutral', 0.12),
                          }}
                        >
                          <Typography sx={{
                            fontSize: '0.65rem',
                            fontWeight: 700,
                            color: isHighlight && isPositive
                              ? getTone('emerald').base
                              : isHighlight && isNegative
                              ? getTone('rose').base
                              : 'text.secondary',
                          }}>
                            {el.status}: {el.priceByStatus}€ ({el.countByStatus}) {el.percentByStatus}%
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Collapse>
              </Box>
            ) : (
              <Box>
                <Link
                  component={RouterLink}
                  to={choiceFormation === "all" && choiceEndDate === "default"
                    ? `/dashboard/formations/${cellValues.row.id}`
                    : `/dashboard/session/${cellValues.row.id}`
                  }
                  sx={{
                    textDecoration: 'none',
                    '&:hover .formation-name': {
                      color: 'secondary.main',
                    },
                  }}
                >
                  <Typography
                    className="formation-name"
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.82rem',
                      color: 'text.primary',
                      lineHeight: 1.35,
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      transition: 'color 0.15s',
                    }}
                  >
                    {cellValues.row.formation}
                  </Typography>
                </Link>
                <Collapse in={cellValues.id === clickedId}>
                  <Box sx={{ mt: 1, pt: 1, borderTop: `1px solid ${greyAlpha(200, 0.7)}` }}>
                    {cellValues.row.status.map((el, idx) => {
                      const isPositive = el.status === 'Inscrit' || el.status === 'InscritD';
                      const isNegative = el.status === 'Annulation' || el.status === 'À décaler';
                      const isHighlight = el.percentByStatus > 49;
                      return (
                        <Box
                          key={idx}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0.5,
                            mr: 0.5,
                            mb: 0.4,
                            px: 1,
                            py: 0.25,
                            borderRadius: '6px',
                            backgroundColor: isHighlight && isPositive
                              ? toneAlpha('emerald', 0.08)
                              : isHighlight && isNegative
                              ? toneAlpha('rose', 0.08)
                              : toneAlpha('neutral', 0.06),
                            border: '1px solid',
                            borderColor: isHighlight && isPositive
                              ? toneAlpha('emerald', 0.2)
                              : isHighlight && isNegative
                              ? toneAlpha('rose', 0.2)
                              : toneAlpha('neutral', 0.12),
                          }}
                        >
                          <Typography sx={{
                            fontSize: '0.65rem',
                            fontWeight: 700,
                            color: isHighlight && isPositive
                              ? getTone('emerald').base
                              : isHighlight && isNegative
                              ? getTone('rose').base
                              : 'text.secondary',
                          }}>
                            {el.status}: {el.priceByStatus}€ ({el.countByStatus}) {el.percentByStatus}%
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Collapse>
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "programNumber",
      headerName: "N° Programme",
      width: 145,
      renderCell: (cellValues) => {
        const val = cellValues.row.formation === "Statistique globale"
          ? null
          : cellValues.row.programNumber;
        if (!val || val === 'N/A') {
          return (
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>—</Typography>
            </Box>
          );
        }
        return (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Box sx={{
              px: 1.2, py: 0.4,
              borderRadius: '8px',
              backgroundColor: toneAlpha('indigo', 0.07),
              border: `1px solid ${toneAlpha('indigo', 0.15)}`,
            }}>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: getTone('indigo').base, fontFamily: 'monospace', letterSpacing: '0.03em' }}>
                {val}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "session",
      width: 115,
      headerName:
        choiceFormation === "all" && choiceEndDate === "default"
          ? "Nb sessions"
          : "Session n°",
      renderCell: (cellValues) => (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Box sx={{
            px: 1.5, py: 0.4,
            borderRadius: '20px',
            backgroundColor: toneAlpha('blue', 0.07),
            border: `1px solid ${toneAlpha('blue', 0.15)}`,
            minWidth: 36,
            textAlign: 'center',
          }}>
            <Typography sx={{ fontSize: '0.78rem', fontWeight: 800, color: 'secondary.main' }}>
              {cellValues.row.session}
            </Typography>
          </Box>
          <Collapse in={cellValues.id === clickedId} />
        </Box>
      ),
    },
    {
      field: "startDate",
      headerName: "Début",
      width: 100,
      renderCell: (cellValues) => {
        const val = cellValues.row.startDate === "-" || cellValues.row.startDate === "N/A"
          ? null
          : moment(cellValues.row.startDate).format("DD/MM/YYYY");
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            {val ? (
              <Box sx={{
                px: 1, py: 0.35,
                borderRadius: '8px',
                backgroundColor: toneAlpha('emerald', 0.06),
                border: `1px solid ${toneAlpha('emerald', 0.15)}`,
              }}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: getTone('emerald').color, fontVariantNumeric: 'tabular-nums' }}>
                  {val}
                </Typography>
              </Box>
            ) : (
              <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>—</Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "endDate",
      headerName: "Fin",
      width: 100,
      renderCell: (cellValues) => {
        const val = cellValues.row.endDate === "-" || cellValues.row.endDate === "N/A"
          ? null
          : moment(cellValues.row.endDate).format("DD/MM/YYYY");
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            {val ? (
              <Box sx={{
                px: 1, py: 0.35,
                borderRadius: '8px',
                backgroundColor: toneAlpha('amber', 0.06),
                border: `1px solid ${toneAlpha('amber', 0.15)}`,
              }}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: getTone('amber').color, fontVariantNumeric: 'tabular-nums' }}>
                  {val}
                </Typography>
              </Box>
            ) : (
              <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>—</Typography>
            )}
          </Box>
        );
      },
    },
    //Joseph_com - Ajout de la section Ville sur le tableaux
    {
      field: "city",
      headerName: "Ville",
      width: 150,
      renderCell: (cellValues) => {
        const val = cellValues.row.city;
        if (!val || val === '-') {
          return (
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>—</Typography>
            </Box>
          );
        }
        return (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Box sx={{
              px: 1.2, py: 0.4,
              borderRadius: '8px',
              backgroundColor: toneAlpha('violet', 0.06),
              border: `1px solid ${toneAlpha('violet', 0.15)}`,
              maxWidth: '100%',
              overflow: 'hidden',
            }}>
              <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: getTone('violet').color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                📍 {val}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "turnoverNotBegun",
      width: 130,
      headerName: "Pas commencé",
      renderCell: (cellValues) => {
        const isAlert = cellValues.row.notBegun > 60;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', py: 0.5 }}>
            <Box sx={{ px: 1.2, py: 0.4, borderRadius: '10px', backgroundColor: isAlert ? toneAlpha('rose', 0.08) : toneAlpha('neutral', 0.06), border: `1px solid ${isAlert ? toneAlpha('rose', 0.2) : toneAlpha('neutral', 0.15)}`, textAlign: 'center', width: '95%' }}>
              <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', color: isAlert ? getTone('rose').base : 'text.secondary', lineHeight: 1.1 }}>
                {cellValues.row.notBegun} % ({cellValues.row.numberNotBegun})
              </Typography>
              <Typography variant="caption" sx={{ fontSize: '0.68rem', color: isAlert ? getTone('rose').base : 'text.secondary', fontWeight: 600, display: 'block', mt: 0.2, opacity: 0.8 }}>
                {cellValues.row.turnoverNotBegun} €
              </Typography>
            </Box>
          </Box>
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "turnoverNotBillable",
      width: 130,
      headerName: "Non facturable",
      renderCell: (cellValues) => {
        const isAlert = cellValues.row.notBillable > 60;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', py: 0.5 }}>
            <Box sx={{ px: 1.2, py: 0.4, borderRadius: '10px', backgroundColor: isAlert ? toneAlpha('amber', 0.08) : toneAlpha('neutral', 0.06), border: `1px solid ${isAlert ? toneAlpha('amber', 0.2) : toneAlpha('neutral', 0.15)}`, textAlign: 'center', width: '95%' }}>
              <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', color: isAlert ? getTone('amber').base : 'text.secondary', lineHeight: 1.1 }}>
                {cellValues.row.notBillable} % ({cellValues.row.numberNotBillable})
              </Typography>
              <Typography variant="caption" sx={{ fontSize: '0.68rem', color: isAlert ? getTone('amber').base : 'text.secondary', fontWeight: 600, display: 'block', mt: 0.2, opacity: 0.8 }}>
                {cellValues.row.turnoverNotBillable} €
              </Typography>
            </Box>
          </Box>
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "turnoverBegun",
      width: 130,
      headerName: "En cours",
      renderCell: (cellValues) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', py: 0.5 }}>
          <Box sx={{ px: 1.2, py: 0.4, borderRadius: '10px', backgroundColor: toneAlpha('indigo', 0.07), border: `1px solid ${toneAlpha('indigo', 0.15)}`, textAlign: 'center', width: '95%' }}>
            <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', color: getTone('indigo').base, lineHeight: 1.1 }}>
              {cellValues.row.begun} % ({cellValues.row.numberBegun})
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '0.68rem', color: getTone('indigo').base, fontWeight: 600, display: 'block', mt: 0.2, opacity: 0.8 }}>
              {cellValues.row.turnoverBegun} €
            </Typography>
          </Box>
        </Box>
      ),
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "turnoverFinished",
      width: 130,
      headerName: "Terminé",
      renderCell: (cellValues) => {
        const isGood = cellValues.row.finished > 60;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', py: 0.5 }}>
            <Box sx={{ px: 1.2, py: 0.4, borderRadius: '10px', backgroundColor: isGood ? toneAlpha('emerald', 0.08) : toneAlpha('neutral', 0.06), border: `1px solid ${isGood ? toneAlpha('emerald', 0.2) : toneAlpha('neutral', 0.15)}`, textAlign: 'center', width: '95%' }}>
              <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', color: isGood ? getTone('emerald').base : 'text.secondary', lineHeight: 1.1 }}>
                {cellValues.row.finished} % ({cellValues.row.numberFinished})
              </Typography>
              <Typography variant="caption" sx={{ fontSize: '0.68rem', color: isGood ? getTone('emerald').base : 'text.secondary', fontWeight: 600, display: 'block', mt: 0.2, opacity: 0.8 }}>
                {cellValues.row.turnoverFinished} €
              </Typography>
            </Box>
          </Box>
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "numberTurnoverRegistered",
      headerName: "Total inscrits",
      width: 145,
      renderCell: (cellValues) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', py: 0.5 }}>
          <Box sx={{ px: 1.5, py: 0.6, borderRadius: '12px', backgroundColor: toneAlpha('blue', 0.08), border: `1px solid ${toneAlpha('blue', 0.2)}`, textAlign: 'center', width: '95%' }}>
            <Typography sx={{ fontWeight: 900, fontSize: '0.85rem', color: 'primary.main', lineHeight: 1.1 }}>
              {cellValues.row.numberTurnoverRegistered} €
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '0.68rem', color: 'text.secondary', fontWeight: 700, display: 'block', mt: 0.2 }}>
              {cellValues.row.numberRegistered} inscrits
            </Typography>
          </Box>
        </Box>
      ),
      sortComparator: (v1, v2) => v1 - v2,
    },
  ];

  const [showStats, setShowStats] = useState(true);

  const handleTabsChange = () => {
    setShowStats(!showStats);
  };

  return (
    <Grid container sx={{ p: 0 }}>
      {/* ── Section Header ── */}
      <Box
        onClick={handleTabsChange}
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          py: 2.5,
          cursor: 'pointer',
          borderBottom: showStats ? 'none' : '1px solid',
          borderColor: greyAlpha(200, 0.6),
          transition: 'background 0.2s',
          '&:hover': {
            backgroundColor: toneAlpha('blue', 0.02),
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{
            width: 40, height: 40, borderRadius: '12px',
            background: `linear-gradient(135deg, ${getTone('blue').base} 0%, ${getTone('indigo').base} 100%)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: `0 4px 12px ${toneAlpha('indigo', 0.25)}`,
            flexShrink: 0,
          }}>
            <KeyboardArrowRightIcon sx={{ color: grey(0), fontSize: '1.2rem' }} />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 800, fontSize: '1rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
              CA par fin de session
            </Typography>
            <Typography sx={{ fontSize: '0.78rem', color: 'text.secondary', fontWeight: 500 }}>
              Vue consolidée par formation — identique au tableau de bord
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{
            px: 1.5, py: 0.4, borderRadius: '8px',
            backgroundColor: showStats ? toneAlpha('neutral', 0.08) : toneAlpha('blue', 0.08),
            border: '1px solid',
            borderColor: showStats ? toneAlpha('neutral', 0.2) : toneAlpha('blue', 0.2),
          }}>
            <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: showStats ? 'text.secondary' : 'primary.main' }}>
              {showStats ? 'Masqué' : 'Affiché'}
            </Typography>
          </Box>
          <IconButton
            size="small"
            sx={{
              backgroundColor: toneAlpha('blue', 0.08),
              border: `1px solid ${toneAlpha('blue', 0.2)}`,
              borderRadius: '10px',
              width: 32, height: 32,
              transition: 'all 0.3s',
              transform: showStats ? 'rotate(0deg)' : 'rotate(180deg)',
            }}
          >
            <KeyboardArrowDownIcon sx={{ color: 'primary.main', fontSize: '1.1rem' }} />
          </IconButton>
        </Box>
      </Box>
      {!showStats && (
        <>
          {/* ── Premium Filter Panel ── */}
          <Box
            sx={{
              mx: 2,
              mt: 2,
              mb: 2,
              p: 2.5,
              borderRadius: '16px',
              backgroundColor: greyAlpha(50, 0.8),
              border: `1px solid ${greyAlpha(200, 0.7)}`,
              backdropFilter: 'blur(12px)',
              width: 'calc(100% - 32px)',
            }}
          >
            <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.08em', mb: 2 }}>
              Filtres
            </Typography>
            <Grid container spacing={2}>
              {/* Année */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <TextField
                  label="Année"
                  name="année"
                  onChange={handleChangeOptionYear}
                  select
                  SelectProps={{ native: true }}
                  value={choiceYear}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                >
                  {yearsOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </TextField>
              </Grid>

              {/* Mois */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <TextField
                  label="Mois"
                  name="month"
                  onChange={handleChangeOptionMonth}
                  select
                  SelectProps={{ native: true }}
                  value={choiceMonth}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  size="small"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                >
                  {monthsOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </TextField>
              </Grid>

              {/* Dates de fin */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    style={{
                      backgroundColor: "transparent",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Dates de fin
                  </InputLabel>
                  <Select
                    multiple
                    value={selectedOptions}
                    onChange={handleChangeOption}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const selectedOption = choiceOptions.find(
                            (option) => option.value === value
                          );
                          return selectedOption ? selectedOption.label : "";
                        })
                        .join(", ")
                    }
                    sx={{ borderRadius: '10px' }}
                  >
                    {choiceOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={selectedOptions.includes(option.value)}
                          size="small"
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {user.id_service === 0 && (
                <>
                  {/* Formation */}
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Autocomplete
                      getOptionLabel={(option) =>
                        `${option.name} ${option.programNumber}`
                      }
                      options={formationsOptions}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(e, value) => {
                        if (value !== null) {
                          setChoiceFormation(value.id);
                          setFormationAutocomplete({
                            id: value.id,
                            name: value.name,
                            programNumber: value.programNumber,
                          });
                        } else {
                          setChoiceFormation("all");
                        }
                      }}
                      value={formationAutocomplete}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Formation"
                          name="formation"
                          variant="outlined"
                          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                        />
                      )}
                    />
                  </Grid>

                  {/* Source */}
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      label="Source"
                      name="source"
                      onChange={handleChangeOptionSource}
                      select
                      SelectProps={{ native: true }}
                      value={choiceSource}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    >
                      {sourcesOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Relance */}
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      label="Relance"
                      name="relance"
                      onChange={handleChangeOptionRelance}
                      select
                      SelectProps={{ native: true }}
                      value={choiceRelance}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    >
                      {relanceOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Profession */}
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      label="Profession"
                      name="profession"
                      onChange={handleChangeOptionProfession}
                      select
                      SelectProps={{ native: true }}
                      value={choiceProfession}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    >
                      {professionsOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Financeur */}
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      label="Financeur"
                      name="financeur"
                      onChange={handleChangeOptionFinanceur}
                      select
                      SelectProps={{ native: true }}
                      value={choiceFinanceur}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    >
                      {financeursOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Joseph_com - Ajout du TextField pour le format */}
                  <Grid item xs={12} sm={6} md={3} lg={2}>
                    <TextField
                      label="Format"
                      name="format"
                      onChange={handleChangeOptionFormat}
                      select
                      SelectProps={{ native: true }}
                      value={choiceFormat}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    >
                      {formatsOptions.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </TextField>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>

          {/* ── DataGrid ── */}
          <Box sx={{ px: 2, pb: 2, width: '100%' }}>
            <DataGrid
              localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "asc" }],
                },
              }}
              autoHeight
              loading={loading}
              rowHeight={70}
              // eslint-disable-next-line consistent-return
              getRowHeight={({ id, densityFactor }) => {
                if (id === clickedId) {
                  return 250 * densityFactor;
                }
              }}
              rows={rows}
              columns={columns}
              pageSize={50}
              rowsPerPageOptions={[15, 25, 50, 100]}
              components={{ Toolbar: GridToolbar }}
              sx={{
                border: `1px solid ${greyAlpha(200, 0.5)}`,
                borderRadius: '12px',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: greyAlpha(50, 0.8),
                  borderBottom: `1px solid ${greyAlpha(200, 0.8)}`,
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: 'text.secondary',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: toneAlpha('blue', 0.02),
                },
                '& .MuiDataGrid-cell': {
                  borderColor: greyAlpha(200, 0.4),
                  whiteSpace: 'normal !important',
                  wordBreak: 'break-word !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                },
                '& .MuiDataGrid-cell[data-field="formation"]': {
                  whiteSpace: 'normal !important',
                  lineHeight: '1.35 !important',
                  display: 'flex !important',
                  alignItems: 'center !important',
                  py: '8px !important',
                  width: '100% !important',
                  overflow: 'visible !important',
                },
              }}
            />
          </Box>
        </>
      )}
    </Grid>
  );
};

export default FinanceStatistiqueFormationsSuperAdmin;
